import { ActionIcon, Divider, Flex, Text, Button } from '@mantine/core';
import { Routes } from '../../../../../route/Routes';
import { Link, useNavigate } from 'react-router-dom';
import { useRepeatedQuestionnaireStore } from '../stores/RepeatedQuestionnaireStore';
import { CheckListId } from '@web/common';
import { CheckListCheckBox } from '../../../../../component';
import { useTranslation } from 'react-i18next';
import { MyIcon } from '@web/common-ui';

export const DialogIntro = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation('repeated-questionnaire');
  const store = useRepeatedQuestionnaireStore();
  const navigate = useNavigate();
  const sf12Done = store.repeatedQuestionnaireFilloutStatus?.sf12;
  const cuditDone = store.repeatedQuestionnaireFilloutStatus?.cudit;

  const bothFilledOut =
    store.repeatedQuestionnaireFilloutStatus.cudit &&
    store.repeatedQuestionnaireFilloutStatus.sf12;

  const noneFilledOut =
    !store.repeatedQuestionnaireFilloutStatus.cudit &&
    !store.repeatedQuestionnaireFilloutStatus.sf12;

  const steps = [
    {
      label: t('cuditDescription'),
      done: cuditDone,
      index: 0,
      route: Routes.RepeatedCannabisConsumptionQuestionnaire,
      checklistId: CheckListId.CannabisConsumptionQuestionnaire,
    },
    {
      label: t('sf12Description'),
      done: sf12Done,
      index: 1,
      route: Routes.RepeatedSF12Questionnaire,
      checklistId: CheckListId.SF12Questionnaire,
    },
  ];

  return (
    <Flex direction="column" gap="10px">
      <Text>{t('Description')}</Text>
      <Divider my="15px" />
      <Text fw="600" lh="24px" size="16px" my="0px 10px">
        {t('EasySteps')}
      </Text>
      {steps.map((step) => (
        <Link
          key={step.index}
          to={step.route}
          state={{ id: step.checklistId }}
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Flex direction="row" gap="10px" key={step.index} align="center">
            <CheckListCheckBox done={step.done} index={step.index} />
            <Text fw="400" size="16px" lh="24px">
              {step.label}
            </Text>
            {!step.done && (
              <ActionIcon variant="white">
                <MyIcon name="chevron_right" />
              </ActionIcon>
            )}
          </Flex>
        </Link>
      ))}

      <Divider m="20px 0px" />

      {!bothFilledOut && (
        <Button
          onClick={() => {
            const nextStep = steps.find((step) => !step.done);
            if (nextStep) {
              navigate(nextStep.route, { state: { id: nextStep.checklistId } });
            }
          }}
          w="100%"
        >
          {noneFilledOut
            ? t('Buttons.FilloutFirstQuestionnaire')
            : t('Buttons.FilloutNextQuestionnaire')}
        </Button>
      )}

      {bothFilledOut && (
        <Button onClick={() => onSuccess()} w="100%" disabled={!bothFilledOut}>
          {t('Done')}
        </Button>
      )}
    </Flex>
  );
};
